// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"PricingTierCard_highlighted__8bXQD","badge":"PricingTierCard_badge__wlfy9","price":"PricingTierCard_price__kjx8C"};